// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'futuraPTProLight', 'futuraPTProLight Fallback'"},"className":"__className_0fb7d2","variable":"__variable_0fb7d2"};